import {applySpec, constant, find, flow, get, ifElse, isUndefined} from '@logistics-frontend/utils'

import {UserFeedback} from 'src/api/cargo-c2c/types'

import {isFeedbackAction} from '../../utils'

export const toUserFeedback = flow(
  get('actions'),
  find(isFeedbackAction),
  get('last_feedback'),
  ifElse(
    isUndefined,
    constant(undefined),
    applySpec<UserFeedback>({
      score: get('score'),
      comment: get('comment'),
      reasonIDs: get('reason_ids'),
    }),
  ),
)
